export default {"src":"/_next/static/image/public/images/ic_android.6a622660a2baa1c86539ac993fd6abcf.svg","height":37,"width":108};